//
//
//
//
//
//
//
//
//

import { TROPHIES_ASSETS } from "@Broker/js/custom/utils";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReferrerTrophy",
  props: {
    position: {
      type: Number,
      required: true
    },
    combinedValue: {
      type: Number,
      default: 0
    }
  },
  computed: {
    trophy() {
      return TROPHIES_ASSETS[this.position];
    },
    trophyTooltip() {
      const value = this.$options.filters.formatMoneyValueLong(this.combinedValue);
      return `${this.$t("referrers.messages.combinedValueMessage")} ${value}`;
    }
  }
});